// SearchAppBar.js
import React from 'react';
import { AppBar, Toolbar, InputBase, Box } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import NotificationDropdown from './NotificationDropdown';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { FaRegBell, FaRegHeart } from 'react-icons/fa';
import { RiMessengerLine } from 'react-icons/ri';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: 20,
  backgroundColor: alpha(theme.palette.common.white, 0.9),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 1),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: ' #9e9e9e',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: '#424242',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(0.8, 0.8, 0.8, 0),
    paddingLeft: `calc(1em + ${theme.spacing(2)})`,
    fontSize: '0.9rem',
    width: '100%',
  },
}));

const SearchAppBar = ({ query, setQuery, handleKeyPress, notificationData, handleNotificationClick }) => {
  return (
    <AppBar
      position="fixed"
      sx={{
        bgcolor: "rgba(232, 217, 183, 0.95)",
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        boxShadow: '0 6px 14px rgba(0,0,0,0.25)',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        borderRadius: '10px',
        height: '48px',
        width: '83%',
        ml: '7.3%',
        mr: '3px',
        mt: '52px',
        zIndex: 1201,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Toolbar sx={{ minHeight: '48px !important', px: 0.75, width: '95%' }}>
        <Search
          sx={{
            flex: 0.99,
            mx: 0.5,
            px: 0.75,
            border: '1px solid black',
            borderRadius: '18px',
          }}
        >
          <SearchIconWrapper>
            <SearchIcon sx={{ fontSize: '1.05rem', color: '#333' }} />
          </SearchIconWrapper>
          <StyledInputBase
            placeholder="Search… Buy, Rent, Lease, Service"
            sx={{ fontSize: '0.8rem', color: '#000', px: 0.75 }}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyPress={handleKeyPress}
          />
        </Search>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <NotificationDropdown
            icon={<FavoriteBorderIcon sx={{ fontSize: '1.15rem', color: '#d32f2f' }} />}
            badgeContent={notificationData?.unread_count_liked || 0}
            notifications={notificationData?.notifications_liked}
            title="Likes"
            emptyMessage="No likes yet"
            onNotificationClick={handleNotificationClick}
          />
          {/*
          <NotificationDropdown
            icon={<FaRegBell style={{ fontSize: '1.15rem', color: '#1976d2' }} />}
            badgeContent={notificationData?.unread_count_newprop || 0}
            notifications={notificationData?.notifications_newprop}
            title="New Properties"
            emptyMessage="No new property notifications"
            onNotificationClick={handleNotificationClick}
          />
          */}

          <NotificationDropdown
            icon={<RiMessengerLine style={{ fontSize: '1.15rem', color: '#673ab7' }} />}
            badgeContent={notificationData?.unread_count_chat || 0}
            notifications={notificationData?.notifications_chat}
            title="Messages"
            emptyMessage="No new messages"
            onNotificationClick={handleNotificationClick}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default SearchAppBar;